import { render, staticRenderFns } from "./addMyCourseBj.vue?vue&type=template&id=713ba187&scoped=true"
import script from "./addMyCourseBj.vue?vue&type=script&lang=js"
export * from "./addMyCourseBj.vue?vue&type=script&lang=js"
import style0 from "./addMyCourseBj.vue?vue&type=style&index=0&id=713ba187&prod&lang=less"
import style1 from "./addMyCourseBj.vue?vue&type=style&index=1&id=713ba187&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713ba187",
  null
  
)

export default component.exports